import { create } from "zustand";
import { toast } from "react-toastify";
import {
  allTicketsData,
  allTicketsStatsData,
  downloadTickets,
  getAllActiveAssignee,
  ticketBulkUpdateV2,
  getAllAssigness,
  statsUserData,
  callAction,
  resolvedUserAssignee,
} from "../api_layer/api";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import _ from "lodash";

const useAllTicketStore = create((set) => ({
  allTicketData: [],
  allAssigneeData: [],
  resolvedAssigneeData: [],
  statsData: [],
  userData: [],
  caseData: [],
  bulkUpdateResponse: "",
  isLoading: false,
  statsLoading: false,
  allTicketLoading: false,
  error: null,
  rowChecked: [],
  ticketStats: {},
  allTicketStats: {},
  allTicketError: null,
  isResolvedAssignee: {},

  fetchAllTicketData: async (sd, ed, newPage, query) => {
    const startDate = moment(sd).startOf("day").toISOString();
    const endDate = moment(ed).endOf("day").toISOString();
    try {
      set({ allTicketLoading: true, allTicketError: null, error: null });
      const response = await allTicketsData(startDate, endDate, newPage, query);
      set({ allTicketData: response.data, allTicketLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        allTicketLoading: false,
      });
    }
  },

  downloadTicket: async (sd, ed, query) => {
    let startDate = moment(sd).startOf("day").toISOString();
    let endDate = moment(ed).endOf("day").toISOString();
    const payload = {
      startDate: startDate,
      endDate: endDate,
    };
    try {
      set({
        downloadTicketsLoading: true,
        allTicketError: null,
        error: null,
      });
      await downloadTickets(query, payload);
      toast.success(`Email sent at ${secureLocalStorage.getItem("email")}`, {
        position: "top-center",
      });
    } catch (error) {
      toast.error(
        `Failed to send email at ${secureLocalStorage.getItem("email")}`,
        {
          position: "top-center",
        }
      );
    } finally {
      set({ downloadTicketsLoading: false });
    }
  },

  allTicketDownload: async (sd, ed, query) => {
    let startDate = moment(sd).startOf("day").toISOString();
    let endDate = moment(ed).endOf("day").toISOString();
    const payload = {
      startDate: startDate,
      endDate: endDate,
    };
    try {
      set({
        downloadTicketsLoading: true,
        allTicketError: null,
        error: null,
      });
      await downloadTickets(query, payload);
      toast.success(`Email sent at ${secureLocalStorage.getItem("email")}`, {
        position: "top-center",
      });
    } catch (error) {
      toast.error(
        `Failed to send email at ${secureLocalStorage.getItem("email")}`,
        {
          position: "top-center",
        }
      );
    } finally {
      set({ downloadTicketsLoading: false });
    }
  },

  fetchAllTicketStats: async (sd, ed, query) => {
    let startDate = moment(sd).startOf("day").toISOString();
    let endDate = moment(ed).endOf("day").toISOString();
    try {
      const response = await allTicketsStatsData(startDate, endDate, query);
      set({ allTicketStats: response.data, ticketStats: response.data });
    } catch (error) {
      console.error("Error fetching all ticket stats:", error);
    }
  },

  fetchUserData: async () => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      const response = await statsUserData();
      set({ userData: response.data, isLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
    }
  },

  fetchCallActionData: async (id) => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      const response = await callAction(id);
      set({ caseData: response.data, isLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
    }
  },

  updateAssignedData: async () => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      const response = await assignedTicketsFilterData("");
      set({ allTicketData: response.data, isLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
    }
  },

  fetchAllActiveAssignee: async () => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      const response = await getAllActiveAssignee();
      set({ allAssigneeData: response.data, isLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
    }
  },

  fetchResolvedAssignees: async () => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      const response = await getAllAssigness();
      set({ resolvedAssigneeData: response.data.assignees, isLoading: false });
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
    }
  },

  fetchResolvedAssigneeStatus: async () => {
    try {
      const response = await resolvedUserAssignee();
      set({ isResolvedAssignee: response.data });
    } catch (error) {
     console.error('error', error);
    }
  },

  setRowChecked: (rowChecked) => set({ rowChecked }),

  bulkTicketUpdated: async (payload) => {
    try {
      set({ isLoading: true, allTicketError: null, error: null });
      if (!payload || !payload.ticketIds || _.isEmpty(payload.ticketIds)) {
        toast.error("Please select at least one ticket");
        return;
      }
      const {current_assignment, action_taker} = payload;
      if(!current_assignment || !action_taker) {
        toast.error("current_assignment/action_taker is missing");
        return;
      }
      const response = await ticketBulkUpdateV2(payload);
      set({ bulkUpdateResponse: response.data, isLoading: false });
      toast.success("Ticket Updated Successfully");
    } catch (error) {
      set({
        allTicketError: error.message,
        error: error.message,
        isLoading: false,
      });
      toast.error("Failed to Update Tickets");
    }
  },
}));

export default useAllTicketStore;
